import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../services/http/auth.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-two-factor-dialog',
  templateUrl: './two-factor-dialog.component.html',  
  styleUrls: ['./two-factor-dialog.component.scss']
})
export class TwoFactorDialogComponent {
  code: string = '';

  constructor(
    private authService: AuthService,
    private dialogRef: MatDialogRef<TwoFactorDialogComponent>,
    private router: Router,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.authService.request2FA().subscribe((data) => {
        if(data.status == 200) {
            this.toastr.success('2FA Code sent to your email.');
        } else if(data.status == 500) {
            this.toastr.error("Error sending email with 2FA code.")
        }
    });
  }

  verifyCode() {
    this.authService.verify2FAPage(this.code).subscribe(
      (data) => {
        if(data.status == 200) {            
            this.authService.set2FAVerified(true);
            this.dialogRef.close();

            const pendingRoute = localStorage.getItem('pendingRoute');
            if (pendingRoute) {
                this.router.navigateByUrl(pendingRoute);
                localStorage.removeItem('pendingRoute'); 
            }
        } else if(data.status == 400) {
            this.toastr.error('Invalid 2FA code.');
        }
      },
      () => {
        this.toastr.error('Invalid 2FA code.');
      }
    );
  }
  cancel() {
    this.dialogRef.close();
  }
}
